  export function camelToSnake(camelCaseString: string): string {
    return camelCaseString.replace(/([A-Z])/g, match => '_' + match.toLowerCase())
  }

  export function snakeToCamel(snakeCaseString: string): string {
    return snakeCaseString.toLowerCase().replace(/(_\w)/g, match => match[1].toUpperCase())
  }